<template>
  <div id="batch-edit" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Edit Batch"></HeaderDividerBlock>

            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Batch Code</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.batch_code"
                  required
                  clearable
                  placeholder="Enter Batch Code"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Manufacture Date</p>
                </v-col>
                <DatePicker
                  v-model="form.manufacture_date"
                  placeholder="Manufacture Date"
                ></DatePicker>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Expiry Date</p>
                </v-col>
                <DatePicker
                  v-model="form.expiry_date"
                  placeholder="Expiry Date"
                ></DatePicker>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Product</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.product_id"
                  required
                  clearable
                  placeholder="Select Product"
                  :items="products"
                  item-text="product_code"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Product Cost</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.cost"
                  required
                  clearable
                  placeholder="Enter Product Cost"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Retail Price</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.retail_price"
                  required
                  clearable
                  placeholder="Enter Retail Price"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-col cols="6" sm="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Wholesale price</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.wholesale_price"
                required
                clearable
                placeholder="Enter Wholesale price"
              ></v-text-field>
            </v-col>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('batch.edit')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                  >
                    Update Batch
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { BatchService } from "@/services/batch-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "BatchEditForm",
  components: {
    Alert,
    Snackbars,
    DatePicker,
    HeaderDividerBlock,
  },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      form: {
        id:"",
        batch_code: "",
        manufacture_date: new Date().toISOString().substr(0, 10),
        expiry_date: new Date().toISOString().substr(0, 10),
        product_id: null,
        cost: "",
        retail_price: "",
        wholesale_price: "",
      },
      products: [],
      search: "",
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchBatchDetails();
    this.fetchProducts();
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const response = await BatchService.updateBatch(
          this.form,
          this.form.id
        );
        this.succesMsg = response.message;
        this.snackbar = true;
      } catch (error) {
        console.error(error);
        this.errors = "Error updating batch";
      } finally {
        this.loading = false;
      }
    },

    async fetchBatchDetails() {
      try {
        const response = await BatchService.getBatchDetails(
          this.$route.params.id
        );
        if (response) {
          const batchData = response;
          this.form.id = batchData.id;
          this.form.batch_code = batchData.batch_code;
          this.form.manufacture_date = batchData.manufacture_date;
          this.form.expiry_date = batchData.expiry_date;
          this.form.product_id = batchData.product_id;

          if (batchData.product_prices && batchData.product_prices.length > 0) {
            this.form.cost = batchData.product_prices[0].cost;
            this.form.retail_price = batchData.product_prices[0].retail_price;
            this.form.wholesale_price =
              batchData.product_prices[0].wholesale_price;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    async fetchProducts() {
      try {
        const products = await BatchService.getProducts();
        this.products = products.data.data;
      } catch (err) {
        console.error(err);
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
